import PaymentService from "../../services/api/payment.service";
import {
  ButtonCloseModal,
  ButtonSaveFileModal,
  CloseButton,
  FileName,
  FileSize,
  PreviewCanvas,
  PreviewContent,
  PreviewFooter,
  PreviewHeader,
  PreviewModal,
  PreviewOverlay,
  PreviewOverlayPreview,
  PreviewTitle,
  ProcessText,
  Spinner,
  ProcessModal,
  ProcessFileCard,
  ProcessFileExt,
  ProcessLoader,
  ProcessTip,
  ButtonPaymentModal,
} from "../../style/AIToolsPage_Style";
import {
  Actions,
  Card,
  CardParent,
  InfoRow,
  Label,
  Status,
  Title,
  Value,
} from "../../style/PaymentComplete_Style";
import Button from "@mui/material/Button";
import { useSearchParams } from "react-router-dom";
import { toast } from "../../utils/notify";
import { EPaymentStatus, HistoryTranslate, UploadFile } from "./AiToolsPage";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ButtonTranslateFileModal,
  PayButton,
} from "../../style/TransactionHistory_Style";
import TranslateService from "../../services/api/translate.service";
import {
  connectSignal,
  getSignalConnection,
} from "../../services/api/signalr.Service";
import pdfjsLib from "../../pdfConfig";
import { EQrcodeRequest } from "../../models/payment";
import { envConfig } from "../../config/env.config";
import { PayPalButtons } from "@paypal/react-paypal-js";

const PaymentComplete = () => {
  const [historyTranslate, setHistoryTranslate] = useState<HistoryTranslate>();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId"); // ✅ jgU1Nywd8UKPZ
  const calledRef = useRef(false);
  const { t } = useTranslation();
  const [isTranslating, setIsTranslating] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewFile, setPreviewFile] = useState<UploadFile | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [files, setFiles] = useState<UploadFile[]>([]);
  const [showProcessModal, setShowProcessModal] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isRenderingPreview, setIsRenderingPreview] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [isCancellingTranslation, setIsCancellingTranslation] = useState(false);

  // Khi user chủ động hủy, bỏ qua SignalR Completed/Failed về trễ của job cũ.
  const cancelRequestedRef = useRef(false);

  useEffect(() => {
    GetHistoryTranslate();
  }, [orderId, showPreviewModal]);

  const GetHistoryTranslate = useCallback(
    async (autoStartTranslate = true) => {
      if (orderId) {
        var res = await PaymentService.GetHistoryTranslate(orderId);
        if (res.success) {
          setHistoryTranslate(res.data);

          if (res.data.status === EPaymentStatus.translate_Processing) {
            return;
          }

          if (
            autoStartTranslate &&
            !cancelRequestedRef.current &&
            res.data.status === EPaymentStatus.success
          ) {
            await handleCreate(res.data);
          }
        } else {
          toast(t("payment.transactionNotFound"), "error");
        }
      } else {
        toast(t("payment.transactionNotFound"), "error");
      }
    },
    [orderId, t],
  );

  const handleGetQrcode = async (orderId: string, price: number) => {
    const data: EQrcodeRequest = {
      orderId: orderId,
      price: price, //previewFile.price ?? 0,
    };

    const qrcode = await PaymentService.GetQrCode(data);

    if (qrcode.success) {
      window.open(qrcode.data, "_blank");
    } else {
      toast(t("transaction.getQrFail"), "error");
    }
  };

  const handleDownloadPreviewFile = async () => {
    if (isDownloading) return;

    try {
      setIsDownloading(true);

      // Cho React kịp render loading trước khi xử lý base64
      await new Promise<void>((resolve) => {
        requestAnimationFrame(() => resolve());
      });

      historyTranslate && (await GetFileHistoryTranslate(historyTranslate?.id));

      // Giữ loading ngắn một chút để user thấy phản hồi
      await new Promise((resolve) => setTimeout(resolve, 600));
    } catch (error) {
      toast("Tải file thất bại", "error");
    } finally {
      setIsDownloading(false);
    }
  };

  const getProcessText = () => {
    return t("translate.ai_processing");
  };

  const formatDate = (date?: string | Date): string => {
    if (!date) return "";

    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const handleCreate = async (historyTranslate: HistoryTranslate) => {
    cancelRequestedRef.current = false;
    setIsCancellingTranslation(false);

    setFiles([
      {
        // Flow createSuccess không upload FileIds như màn dịch file ban đầu.
        // Dùng orderId làm cancelKey để client và backend có cùng một key ổn định.
        id: historyTranslate.orderId,
        fileName: historyTranslate.fileName,
        fileSize: historyTranslate.fileSize,
        status: EPaymentStatus.pending,
        progress: 0,
        isTranslating: true,
        orderId: historyTranslate.orderId,
      },
    ]);

    setShowProcessModal(true);
    setIsTranslating(true);

    try {
      await TranslateService.createSuccess(historyTranslate);
    } catch (error) {
      if (cancelRequestedRef.current) {
        return;
      }

      toast(t("error.translate_fail"), "error");
      setShowProcessModal(false);
      setIsTranslating(false);
      setFiles([]);
    }
  };

  // const renderPdf = async () => {
  //   if (!previewFile?.previewBase64) return;
  //   await GetHistoryTranslate(false);

  //   setIsRenderingPreview(true);

  //   const container = document.getElementById("pdf-preview-container");
  //   if (!container) return;

  //   container.innerHTML = "";

  //   try {
  //     const base64 =
  //       previewFile.previewBase64 && previewFile?.previewBase64.split(",")[1];

  //     if (base64) {
  //       const pdfData = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

  //       const pdf = await pdfjsLib.getDocument({
  //         data: pdfData,
  //       }).promise;

  //       const numberOfTranslationServicesUsed =
  //         (previewFile.totalNumberOfTranslationServicesUsed ?? 0) -
  //         (previewFile.numberOfTranslationServicesUsed ?? 0);

  //       let pageCountReview = 5;

  //       if (numberOfTranslationServicesUsed < 0) pageCountReview = 1;

  //       const maxPages = Math.min(pageCountReview, pdf.numPages);

  //       for (let i = 1; i <= maxPages; i++) {
  //         const page = await pdf.getPage(i);

  //         const containerWidth = container.clientWidth;

  //         const viewport = page.getViewport({
  //           scale: containerWidth / page.getViewport({ scale: 1 }).width,
  //         });

  //         const outputScale = window.devicePixelRatio || 1;

  //         const canvas = document.createElement("canvas");

  //         const context = canvas.getContext("2d")!;

  //         canvas.width = viewport.width * outputScale;
  //         canvas.height = viewport.height * outputScale;

  //         canvas.style.width = "100%";
  //         canvas.style.height = "auto";
  //         canvas.style.display = "block";
  //         canvas.style.marginBottom = "16px";

  //         await page.render({
  //           canvasContext: context,
  //           viewport,
  //           transform:
  //             outputScale !== 1
  //               ? [outputScale, 0, 0, outputScale, 0, 0]
  //               : undefined,
  //         }).promise;

  //         container.appendChild(canvas);
  //       }
  //     }
  //   } finally {
  //     setIsRenderingPreview(false);
  //   }
  // };

  // useEffect(() => {
  //   renderPdf();
  // }, [showPreviewModal, previewFile]);

  useEffect(() => {
    let conn: any;

    const initSignalR = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      conn = await connectSignal(token);

      conn.off("TranslateCompleted");
      conn.off("TranslateFailed");
      conn.off("TranslateCancelled");

      conn.on("TranslateCompleted", async (data: HistoryTranslate) => {
        // Job cũ có thể trả Completed đúng lúc user vừa bấm Hủy.
        if (cancelRequestedRef.current) {
          return;
        }

        setShowProcessModal(false);
        setShowPreviewModal(true);

        try {
          const filePreview = await TranslateService.getFilePreview(
            data.orderId,
          );

          setPreviewFile({
            id: filePreview.data.id,
            file: new File([], filePreview.data.fileName),
            status: filePreview.data.status,
            progress: 100,
            isTranslating: false,
            orderId: filePreview.data.orderId,
            price: filePreview.data.price,
            previewBase64: buildPreviewImageUrl(
              filePreview.data.filePreviewBase64,
            ),
            fileBase64: filePreview.data.fileDownloadBase64,
            fileName: filePreview.data.fileName,
            numberOfTranslationServicesUsed:
              filePreview.data.numberOfTranslationServicesUsed,
            totalNumberOfTranslationServicesUsed:
              filePreview.data.totalNumberOfTranslationServicesUsed,
          });
        } catch (error) {
          toast(t("error.translate_fail"), "error");
          setShowPreviewModal(false);
        } finally {
          setIsTranslating(false);

          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        }
      });

      conn.on("TranslateFailed", () => {
        if (cancelRequestedRef.current) {
          return;
        }

        toast(t("error.translate_fail"), "error");
        setShowProcessModal(false);
        setShowPreviewModal(false);
        setIsTranslating(false);
        setFiles([]);
      });

      conn.on("TranslateCancelled", () => {
        cancelRequestedRef.current = true;
        setShowProcessModal(false);
        setShowPreviewModal(false);
        setIsTranslating(false);
        setIsCancellingTranslation(false);
        setFiles([]);
      });
    };

    initSignalR();

    return () => {
      const conn = getSignalConnection();
      conn?.off("TranslateCompleted");
      conn?.off("TranslateFailed");
      conn?.off("TranslateCancelled");
    };
  }, []);

  const buildPreviewImageUrl = (path?: string) => {
    if (!path) return "";

    if (/^https?:\/\//i.test(path)) {
      return path;
    }

    const baseUrl = envConfig.API_ENDPOINT.replace(/\/api\/?$/i, "").replace(
      /\/$/g,
      "",
    );

    const cleanPath = path.startsWith("/") ? path : `/${path}`;

    return encodeURI(`${baseUrl}${cleanPath}`);
  };

  const GetFileHistoryTranslate = async (id: string) => {
    const res = await PaymentService.GetFileHistoryTranslate(id);

    if (res.success) {
      await downloadUrlFile(res.data.fileDownloadBase64, res.data.fileName);
      toast(res.message, "success");
    } else {
      toast(res.message, "error");
    }
  };

  const buildFileUrl = (path?: string) => {
    if (!path) return "";

    if (/^https?:\/\//i.test(path)) {
      return path;
    }

    const baseUrl = envConfig.API_ENDPOINT.replace(/\/api\/?$/i, "").replace(
      /\/$/g,
      "",
    );

    const cleanPath = path.startsWith("/") ? path : `/${path}`;

    return encodeURI(`${baseUrl}${cleanPath}`);
  };

  const downloadUrlFile = async (fileUrl: string, fileName?: string) => {
    const finalUrl = buildFileUrl(fileUrl);

    if (!finalUrl) {
      toast("Không tìm thấy đường dẫn file", "error");
      return;
    }

    try {
      const response = await fetch(finalUrl);

      if (!response.ok) {
        throw new Error("Download failed");
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName || "translated-file";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      // Fallback nếu bị CORS hoặc server không cho fetch trực tiếp
      window.open(finalUrl, "_blank");
    }
  };

  const createOrder = async (customOrderId?: string | null, price?: number) => {
    const res = await fetch(
      envConfig.API_ENDPOINT +
        `/paypal/create-order?customOrderId=${customOrderId}&price=${price}`,
      {
        method: "POST",
      },
    );

    if (!res.ok) {
      toast("Tạo thanh toán thất bại", "error");
      return;
    }

    const data = await res.json();
    return data.id;
  };

  const onApprove = async (data: any, customOrderId?: string) => {
    await fetch(
      envConfig.API_ENDPOINT +
        `/paypal/capture-order?orderId=${data.orderID}&customOrderId=${customOrderId}`,
      { method: "POST" },
    );

    toast("Thanh toán PayPal thành công", "success");

    setShowPaymentModal(false);

    // cập nhật trạng thái file đã thanh toán
    setFiles((prev) =>
      prev.map((f) =>
        f.id === previewFile?.id ? { ...f, status: EPaymentStatus.success } : f,
      ),
    );

    envConfig.KEY_BASE === "vn"
      ? window.open(
          "https://docme.vn/transaction?orderId=" + customOrderId,
          "_blank",
        )
      : window.open(
          "https://docme.world/transaction?orderId=" + customOrderId,
          "_blank",
        );
  };

  const processFile = files.find((f) => f.isTranslating) || files[0];

  const processFileName =
    processFile?.file?.name || processFile?.fileName || "Document";

  const processFileSize = processFile?.file?.size
    ? `${(processFile.file.size / 1024 / 1024).toFixed(2)} MB`
    : processFile?.fileSize
      ? `${(processFile.fileSize / 1024 / 1024).toFixed(2)} MB`
      : "";

  const processFileExt =
    processFileName.split(".").pop()?.toUpperCase() || "FILE";

  const handleCancelTranslation = async () => {
    if (!processFile || isCancellingTranslation) return;

    // Ở PaymentComplete, processFile.id được set bằng orderId.
    // Nhờ vậy cancelKey và orderId đều xác định đúng job đang chạy.
    const cancelKey = processFile.id || processFile.orderId;
    const currentOrderId = processFile.orderId || orderId;

    if (!cancelKey) {
      toast(
        t("translation.cancelFailed", {
          defaultValue: "Không thể xác định tiến trình cần hủy.",
        }),
        "error",
      );
      return;
    }

    // Set trước khi gọi API để Completed/Failed về đúng lúc này cũng bị bỏ qua.
    cancelRequestedRef.current = true;
    setIsCancellingTranslation(true);

    try {
      const token = localStorage.getItem("token");
      const apiBase = envConfig.API_ENDPOINT.replace(/\/$/, "");

      const response = await fetch(`${apiBase}/translate/cancel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          cancelKey,
          orderId: currentOrderId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Cancel translation failed: ${response.status}`);
      }

      const result = await response.json().catch(() => null);

      if (result && result.success === false) {
        throw new Error(result.message || "Cancel translation failed");
      }

      // Đóng modal ngay sau khi backend xác nhận đã nhận yêu cầu hủy.
      setShowProcessModal(false);
      setShowPreviewModal(false);
      setIsTranslating(false);
      setFiles([]);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      toast(
        t("translation.cancelled", {
          defaultValue: "Đã hủy quá trình dịch tệp.",
        }),
        "info",
      );

      // Refresh trạng thái giao dịch nhưng không tự chạy lại dịch.
      await GetHistoryTranslate(false);
    } catch (error) {
      console.error("Cancel translation error:", error);

      // Nếu API hủy thất bại thì tiếp tục nhận Completed/Failed của job hiện tại.
      cancelRequestedRef.current = false;

      toast(
        t("translation.cancelFailed", {
          defaultValue: "Không thể hủy quá trình dịch. Vui lòng thử lại.",
        }),
        "error",
      );
    } finally {
      setIsCancellingTranslation(false);
    }
  };

  return (
    <>
      <CardParent>
        <Card>
          <Title>{t("payment.complete.title")}</Title>
          <InfoRow>
            <Label>{t("payment.fileName")}</Label>{" "}
            <Value>{historyTranslate?.fileName}</Value>
          </InfoRow>

          <InfoRow>
            <Label>{t("payment.fileSize")}</Label>

            <Value>
              {historyTranslate?.fileSize &&
                (historyTranslate?.fileSize / 1024 / 1024).toFixed(2)}{" "}
              MB
            </Value>
          </InfoRow>

          <InfoRow>
            <Label>{t("payment.translateFrom")}</Label>
            <Value>
              {historyTranslate?.from} → {historyTranslate?.to}
            </Value>
          </InfoRow>

          <InfoRow>
            <Label>{t("payment.paymentStatus")}</Label>
            <Value>
              <Status paid={historyTranslate?.status}>
                {historyTranslate?.status == EPaymentStatus.success ||
                historyTranslate?.status ==
                  EPaymentStatus.translate_Processing ||
                historyTranslate?.status == EPaymentStatus.translate_Completed
                  ? "Đã thanh toán"
                  : "Chưa thanh toán"}
              </Status>
            </Value>
          </InfoRow>

          <InfoRow>
            <Label>{t("payment.expirationDate")}</Label>
            <Value>
              {historyTranslate?.expirationDate
                ? formatDate(historyTranslate?.expirationDate)
                : ""}
            </Value>
          </InfoRow>

          <Actions>
            {historyTranslate?.status === EPaymentStatus.translate_Completed ? (
              <ButtonSaveFileModal
                disabled={isDownloading}
                onClick={handleDownloadPreviewFile}>
                {isDownloading ? (
                  <>
                    <Spinner
                      style={{
                        width: 16,
                        height: 16,
                        borderWidth: 2,
                        borderColor: "rgba(111,69,114,0.25)",
                        borderTopColor: "#6f4572",
                      }}
                    />
                    {t("common.loading")}...
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeWidth="0.8"
                      className="bi bi-download">
                      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                    </svg>
                    {t("preview.download")}
                  </>
                )}
              </ButtonSaveFileModal>
            ) : historyTranslate?.status === EPaymentStatus.success ? (
              <ButtonTranslateFileModal
                onClick={() =>
                  historyTranslate && handleCreate(historyTranslate)
                }
                disabled={isTranslating}>
                <>
                  <img
                    style={{ filter: "invert(1)" }}
                    width={"20px"}
                    src="/icon/ai-file_9812085.png"
                  />{" "}
                  {t("file.translate_now")}
                </>
              </ButtonTranslateFileModal>
            ) : historyTranslate?.status ===
              EPaymentStatus.translate_Processing ? (
              <ButtonTranslateFileModal
                // onClick={() =>
                //   historyTranslate && handleCreate(historyTranslate)
                // }
                disabled>
                <>{t("file.translating_short_complete")}</>
              </ButtonTranslateFileModal>
            ) : (
              <PayButton
                onClick={() => {
                  setShowPaymentModal(true);
                }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  strokeWidth="0.8"
                  className="bi bi-credit-card"
                  viewBox="0 0 16 16">
                  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                  <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z" />
                </svg>
                {t("transaction.pay")}
              </PayButton>
            )}
          </Actions>
        </Card>
      </CardParent>

      {showPreviewModal && (
        <PreviewOverlayPreview>
          <PreviewModal>
            <PreviewHeader>
              <PreviewTitle>{t("preview.title")}</PreviewTitle>
              <CloseButton onClick={() => setShowPreviewModal(false)}>
                ✕
              </CloseButton>
            </PreviewHeader>

            <PreviewContent
              style={{
                position: "relative",
                minHeight: 500,
              }}>
              {isRenderingPreview && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgba(255,255,255,.92)",
                    backdropFilter: "blur(6px)",
                    zIndex: 999,
                    gap: 24,
                  }}>
                  <div
                    style={{
                      width: 70,
                      height: 70,
                      borderRadius: "50%",
                      border: "5px solid #dbeafe",
                      borderTop: "5px solid #2563eb",
                      animation: "spin 1s linear infinite",
                    }}
                  />

                  <div
                    style={{
                      width: 260,
                      height: 6,
                      background: "#e5e7eb",
                      borderRadius: 999,
                      overflow: "hidden",
                    }}>
                    <div
                      style={{
                        width: "40%",
                        height: "100%",
                        borderRadius: 999,
                        background:
                          "linear-gradient(90deg,#2563eb,#60a5fa,#2563eb)",
                        animation: "loadingBar 1.2s infinite ease-in-out",
                      }}
                    />
                  </div>

                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: "#1e3a8a",
                    }}>
                    {t("preview.loading_title")}
                    <span className="loading-dots">...</span>
                  </div>

                  <div
                    style={{
                      color: "#6b7280",
                      fontSize: 14,
                    }}>
                    {t("preview.loading_desc")}
                  </div>
                </div>
              )}

              <div id="pdf-preview-container">
                {previewFile?.previewBase64 && (
                  <img
                    src={previewFile.previewBase64}
                    alt={previewFile.fileName || "Preview"}
                    onLoad={() => setIsRenderingPreview(false)}
                    onError={() => {
                      setIsRenderingPreview(false);
                      toast(
                        t("error.preview_fail") || t("error.translate_fail"),
                        "error",
                      );
                    }}
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                      borderRadius: 12,
                      background: "#ffffff",
                    }}
                  />
                )}
              </div>
            </PreviewContent>

            <PreviewFooter>
              <i className="footer-item-i">
                <img
                  style={{
                    filter:
                      "invert(17%) sepia(96%) saturate(7492%) hue-rotate(358deg) brightness(95%) contrast(112%)",
                  }}
                  width={30}
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADLUlEQVR4nO2YW4hNURjHf2MuucygiJmU5JIXFMIULxMPGl7IpcjgxVAYl7yIBxQKD3gYPLhElIRccsklNSGM3MaDW8gYd7mEGWO2Vv67lm3O6Zyz9z7nqP2r1Tn722t93/r2+tZa31oQERERERERERhtgErgNtAIOCGXJqAOWAzkBecG7ElD550Y5USqzhQBm4DHwFPgghR+BSqAQsKnEJgNfJHtpckqGAA8iPFl5pJ+Zsr2/WQajQI+qOEtYDBQAjRLZkYq3bSX7Z+JVM7R0DWp0XEpcHGypMSlizpuKrYAm1uZWFnvyHDgiSp9AqbEqJe1juQAVVYoXQd6x3E4Kx0pAc5aobQRyI83bInGaIg4XvvjgTcSvtVzSorSjOPabwts1QgYwRmNTNKK4pALlAFbFKr3gJ1AP38+/G3/pv58BxZpjhCQI/nagWNtombk+yRpL6b9Bm1wA0mN1hwpUkL3zHpvUprVQKlG4ojk+1K0+4/9fGWvBOBIMbDWygAcZakzWtl/+uq9qesHJ6g56iraAfywni8B4+KEamfVawrIvi+GeWL+F3AIGJFA2wq1uZNJR3KAY5aSb0C1wiURzAR/obYLyaAjecAr4D2wBuiWRNuRQL2MXwnghOf4Da0OQEES9XvqJOnuV9eArn46wJ+P4IZ06AwBdlm5m/ldB7QLQHepdJplPjTGArXW0Ddrz+gfgO5cLSh10r2BkJhsjUDY5S7QMQwnpuvoGWbnW4DnugTpFIYTlZp4xtgqYJb+H/DUq5Z8gecg5ygvyxgmxVlurUhmSTas0PN6T/2TkpdbsiWSmQ017ZgjwCTgqrUMmtOly37J53na1Ug+2lpGTaw7ypZ9dai7stKhwBhgopSajq3UyrAdOAic0vWody5clL4CJY+u3CSNNuesThu72/Rc72dZvuxj0jWq81W6aTSyl8BnT729SmtMmW+FoONJc8r8jEaNOmSOuY+AG8B54DCwW1dAJuaXAXOAqToGD9JIukwD3lmrSq1uAl0HG3TF6r4/DbwGPgJHpS9rMBtVL6XoLuX6QO6XfwhM4D+mGOjh8xAXERERERERQRx+A1Ns/jikzsHQAAAAAElFTkSuQmCC"
                  alt="card-in-use"></img>{" "}
                {t("preview.note")}
              </i>

              <div className="footer-item-div">
                <ButtonSaveFileModal
                  disabled={isDownloading}
                  onClick={() =>
                    previewFile?.status ===
                      EPaymentStatus.translate_Completed &&
                    handleDownloadPreviewFile()
                  }>
                  {isDownloading ? (
                    <>
                      <Spinner
                        style={{
                          width: 16,
                          height: 16,
                          borderWidth: 2,
                          borderColor: "rgba(111,69,114,0.25)",
                          borderTopColor: "#6f4572",
                        }}
                      />
                      {t("common.loading")}...
                    </>
                  ) : (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="0.8"
                        className="bi bi-download">
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                      </svg>
                      {t("preview.download")}
                    </>
                  )}
                </ButtonSaveFileModal>

                <ButtonCloseModal onClick={() => setShowPreviewModal(false)}>
                  {t("common.close")}
                </ButtonCloseModal>
              </div>
            </PreviewFooter>
          </PreviewModal>
        </PreviewOverlayPreview>
      )}

      {showProcessModal && processFile && (
        <PreviewOverlay
          style={{
            background: "rgba(15, 23, 42, 0.62)",
            backdropFilter: "blur(8px)",
          }}>
          <ProcessModal>
            <PreviewHeader
              style={{
                borderBottom: "none",
                paddingBottom: 0,
                position: "relative",
                justifyContent: "center",
              }}>
              <PreviewTitle
                style={{
                  textAlign: "center",
                  fontSize: 20,
                  fontWeight: 800,
                }}>
                {t("file.translating_short_complete")}
              </PreviewTitle>

              <CloseButton
                type="button"
                aria-label={t("translation.cancelTranslation", {
                  defaultValue: "Hủy dịch",
                })}
                disabled={isCancellingTranslation}
                onClick={handleCancelTranslation}
                style={{
                  position: "absolute",
                  right: 0,
                  top: -6,
                  opacity: isCancellingTranslation ? 0.55 : 1,
                  cursor: isCancellingTranslation ? "not-allowed" : "pointer",
                }}>
                ✕
              </CloseButton>
            </PreviewHeader>

            <PreviewContent
              style={{
                marginTop: 18,
                padding: 0,
                background: "transparent",
                maxHeight: "unset",
                overflow: "visible",
                textAlign: "center",
              }}>
              <ProcessFileCard>
                <ProcessFileExt>{processFileExt}</ProcessFileExt>

                <div style={{ minWidth: 0, textAlign: "left" }}>
                  <FileName style={{ maxWidth: 330 }}>
                    {processFileName}
                  </FileName>

                  <FileSize>
                    {processFileSize}
                    {processFileSize ? " · " : ""}
                    Đang xử lý
                  </FileSize>
                </div>
              </ProcessFileCard>

              <ProcessLoader aria-hidden="true">
                <span />
                <span />
                <span />
                <i />
              </ProcessLoader>

              <ProcessText>{getProcessText()}</ProcessText>

              <ProcessTip>{t("translation.keepThisPageOpen")}</ProcessTip>

              <ProcessTip>{t("translation.emailNotice")}</ProcessTip>

              <ButtonCloseModal
                type="button"
                disabled={isCancellingTranslation}
                onClick={handleCancelTranslation}
                style={{
                  marginTop: 18,
                  minWidth: 140,
                  opacity: isCancellingTranslation ? 0.65 : 1,
                }}>
                {isCancellingTranslation
                  ? t("translation.cancelling", {
                      defaultValue: "Đang hủy...",
                    })
                  : t("translation.cancelTranslation", {
                      defaultValue: "Hủy dịch",
                    })}
              </ButtonCloseModal>
            </PreviewContent>
          </ProcessModal>
        </PreviewOverlay>
      )}

      {showPaymentModal && (
        <PreviewOverlay>
          <PreviewModal style={{ maxWidth: 420 }}>
            <PreviewHeader>
              <PreviewTitle>{t("preview.choose_payment_method")}</PreviewTitle>
              <CloseButton onClick={() => setShowPaymentModal(false)}>
                ✕
              </CloseButton>
            </PreviewHeader>

            <PreviewContent
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 16,
                padding: 20,
              }}>
              {envConfig.KEY_BASE === "vn" ? (
                <>
                  {/* VietQR */}
                  <ButtonPaymentModal
                    sx={{ justifyContent: "center" }}
                    onClick={() => {
                      historyTranslate &&
                        handleGetQrcode(
                          historyTranslate.orderId,
                          historyTranslate.price,
                        );
                    }}>
                    <img
                      style={{
                        height: "20px",
                        filter: "drop-shadow(0px 1px 1px white)",
                      }}
                      src="/icon/VietQR.46a78cbb.png"
                    />{" "}
                    🇻🇳 VietQR
                  </ButtonPaymentModal>
                </>
              ) : (
                <>
                  {/* PayPal */}
                  <div style={{ marginTop: 10 }}>
                    <PayPalButtons
                      style={{ layout: "vertical" }}
                      createOrder={() =>
                        createOrder(
                          historyTranslate?.orderId,
                          historyTranslate?.price,
                        )
                      }
                      onApprove={(data) =>
                        onApprove(data, historyTranslate?.orderId)
                      }
                    />
                  </div>
                </>
              )}
            </PreviewContent>
          </PreviewModal>
        </PreviewOverlay>
      )}
    </>
  );
};

export default PaymentComplete;
